import { graphql } from 'react-relay';

export const archiveFileLinkFragment = graphql`
    fragment ArchiveFileLink_archiveFileLink on ArchiveFileLink {
        date
        doctypeheader
        header
        text
        url
        format
        size
        icon
    }
`;
